import { useEffect, useState } from 'react';
import { api } from '../api/client';
import type { AuditEventInfo } from '../api/types';

const KIND_COLORS: Record<string, string> = {
  grant: '#2ba05a',
  revoke: '#b3423a',
  system: '#3b5bd6',
  create: '#2ba05a',
  update: '#3b5bd6',
  'profile-update': '#3b5bd6',
  suspend: '#c98a1a',
  reactivate: '#2ba05a',
  activate: '#2ba05a',
  delete: '#b3423a',
};

function formatTime(iso: string): string {
  const date = new Date(iso);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
  });
}

export function AuditPage() {
  const [events, setEvents] = useState<AuditEventInfo[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    api
      .audit()
      .then((rows) => {
        setEvents(rows);
        setError(null);
      })
      .catch((cause: unknown) => {
        setError(cause instanceof Error ? cause.message : String(cause));
      })
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="page page-audit">
      <h1>Audit log</h1>
      <div className="page-sub">Every access change, recorded.</div>

      {error && <div className="error-banner">{error}</div>}

      <div className="card audit-card">
        {loading && <div className="empty-state">Loading audit log…</div>}
        {!loading &&
          events.map((event) => (
            <div key={event.id} className="audit-row">
              <div
                className="audit-dot"
                style={{ background: KIND_COLORS[event.kind] ?? '#8a918d' }}
              />
              <div className="audit-body">
                <div className="audit-line">
                  <strong>{event.actor}</strong> {event.action}{' '}
                  <strong>{event.target}</strong>
                </div>
                <div className="audit-detail">{event.detail}</div>
              </div>
              <div className="audit-time mono">{formatTime(event.occurredAt)}</div>
            </div>
          ))}
        {!loading && events.length === 0 && (
          <div className="empty-state">No audit events yet.</div>
        )}
      </div>
    </div>
  );
}
